import { Side } from '@/connect';

export function oppositeSide(side: Side): Side {
  switch (side) {
    case Side.BORROW:
      return Side.LOAN;
    case Side.LOAN:
      return Side.BORROW;
    default:
      return Side.BORROW;
  }
}
